var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortIconAZ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-arrow-down-az-icon lucide-arrow-down-a-z",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3 16 4 4 4-4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 20V4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8h-5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14h5l-5 6h5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIconAZ);
export default __webpack_public_path__ + "static/media/sort-icon-a-z.dbc099b4c7277b38c3e8922a5ee9a846.svg";
export { ForwardRef as ReactComponent };